import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import {number_format,number_input_format} from '../helper/format';
import $ from 'jquery';
import checkbox from 'pretty-checkbox';
import {
  isMobile
} from "react-device-detect";

export default class Addpopup extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            open: false,
            services: [],
            selected_services: []
        };
        //this.selected_service_index = [];
    }
    Open(selected_item)
    {
        this.setState({
            open: true
        }, this.requestData);
    }
    Close()
    {
        this.setState({
            open: false
        });
    }
    requestData()
    {
        const self = this;
        $.post('https://api.tfamily.co.kr/api/mobile/base',
        {},
        function(data){
            const parsedData = JSON.parse(data);
            let items = parsedData.data.aservice;
            self.setState({
                services : items
            });
        });
    }

    removeItem(array, value) {
      var index = null;

      while ((index = array.indexOf(value)) !== -1)
          array.splice(index, 1);

      return array;
    }

    isChecked(item)
    {
      let itemArray = this.state.selected_services;
      let result = false;
      for ( let i = 0 ; i < itemArray.length ; i++ )
      {
        if( itemArray[i].name == item.name )
        {
          result = true;
          break;
        }
      }
      return result;
    }

    add(item, index)
    {
        let obj = document.getElementById('key'+index);
        let itemArray = this.state.selected_services;
        if( obj.checked ) {
            obj.checked = false;
            for ( let i = 0 ; i < itemArray.length ; i++ )
            {
                if(item.name == itemArray[i].name) {
                  itemArray.splice(i, 1);
                }
            }
        } else {
            obj.checked = true;
            itemArray.push(item);
        }
        this.setState({
          selected_services: itemArray
        });
    }
    Apply()
    {
      /*
      let pass = [];
      for(let i = 0 ; i < this.selected_service_index.length ;i++)
      {
        let index = this.selected_service_index[i];
        pass.push(this.state.services[index]);
      }
      */
      this.props.onAddChanged(this.state.selected_services);
      this.Close();
    }
    onCheckChanged()
    {

    }
    render()
    {
        const self = this;
        return(
            <Modal open={this.state.open} onClose={()=>{self.Close()}} center>
                <div className="modal-dialog modal-lg mb0">
                    <div className={(isMobile)? 'popupPaddding3' : 'popupPadding pr45'}>
                        <div className="md-popup-header"> &nbsp;부가서비스</div>
                        <div className="row pl15 pr15">
                            <table className="table guideTable mb0">
                                <tbody>
                                    <tr>
                                        <td className="width60"></td>
                                        <td className="width150">서비스명</td>
                                        { (isMobile) ? null : <td>상세설명</td> }
                                        <td className="text-center width150">이용요금</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="scroll400">
                            <table className="table priceTable">
                                <tbody>
                                    {self.state.services.map((item,index)=>{
                                        let check = self.isChecked(item), displayCheck = '';
                                        if( check )
                                        {
                                          displayCheck = "checked";
                                        }
                                        return (
                                            <tr onClick={()=>{self.add(item, index)}} key={index}>
                                                <td className="width60">
                                                    <div className="pretty p-icon p-round p-smooth opa1">
                                                        {(check) ? <input disabled  type="checkbox" id={'key'+index} checked="checked" /> : <input disabled  type="checkbox" id={'key'+index} /> }
                                                        <div className="state p-success">
                                                            <i className="icon fa fa-check"></i>
                                                            <label></label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="width150"><b>{item.name}</b></td>
                                                  { (isMobile) ? null : <td>
                                                    {item.description}
                                                </td>}
                                                <td className="text-center width150">
                                                    {number_input_format(item.price)} 원
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                            </div>
                            <div className="row text-center">
                                <a href="#applyPrice" onClick={()=>{self.Apply()}} className="btn btn-bar btn-lg btn-select2">확인</a>&nbsp;&nbsp;&nbsp;&nbsp;
                                <a href="#cancel" onClick={()=>{self.Close()}} className="btn btn-cancel btn-lg btn-select2">취소</a>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}
